var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotEqual = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.113 4.738a.725.725 0 00-1.026-1.026L10.3 6.5H3.725a.725.725 0 100 1.45H8.85L6.8 10H3.725a.725.725 0 000 1.45H5.35l-1.49 1.49a.725.725 0 101.025 1.025l2.516-2.515h6.874a.725.725 0 000-1.45H8.851l2.05-2.05h3.374a.725.725 0 000-1.45h-1.924l1.762-1.762z",
  fill: "#4E5252"
})));
export default SvgNotEqual;